<script setup lang="ts">
import type { CheckoutTrialSummary } from '~/types/checkout-trial'
import { useBillingStore } from '~/store/billing'
defineProps<CheckoutTrialSummary>()
const billing = useBillingStore()
const { locale } = useI18n()
</script>

<template>
  <div data-testid="checkout-trial-summary" class="space-y-3" aria-live="polite">
    <p class="text-xl font-bold">{{ $t('trial.zeroToday', { zero: billing.formatCents('0') }) }}</p>
    <dl class="space-y-2 text-sm">
      <div class="flex items-start justify-between gap-3">
        <dt class="text-muted">{{ $t('trial.summary.ends') }}</dt>
        <dd class="text-right font-medium">
          {{ new Date(endsAt).toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' }) }}
        </dd>
      </div>
      <div class="flex items-start justify-between gap-3">
        <dt class="text-muted">{{ $t('trial.summary.renewal') }}</dt>
        <dd class="text-right">
          <template v-if="renewalMicroCents !== null">
            <span class="font-medium tabular-nums">{{ billing.formatMicroCents(renewalMicroCents) }}</span>
            <span class="block text-xs text-muted">{{ termLabel }}</span>
          </template>
          <span v-else class="text-muted">{{ $t('billing.page.checkout.summary.calculating') }}</span>
        </dd>
      </div>
      <template v-if="creditMicroCents">
        <div class="flex justify-between gap-3 border-t border-default pt-2">
          <dt class="text-muted">{{ $t('trial.summary.credit') }}</dt>
          <dd class="font-medium tabular-nums">{{ billing.formatMicroCents(creditMicroCents) }}</dd>
        </div>
        <div class="flex justify-between gap-3">
          <dt class="text-muted">{{ $t('trial.summary.used') }}</dt>
          <dd class="font-medium tabular-nums">{{ billing.formatMicroCents(usedMicroCents) }}</dd>
        </div>
      </template>
    </dl>
  </div>
</template>
